__turbopack_context__.v({
  "collapsibleContent": "collapsible-module-scss-module__mx_jAq__collapsibleContent",
  "collapsibleTrigger": "collapsible-module-scss-module__mx_jAq__collapsibleTrigger",
});
